<template>
	<div class="product-info" v-bind:style="getProductStyle" @click="productClick">
    <img class="product-icon"  v-bind:style="getProductLabelStyle"   src='../../../assets/image/activity/goodProject@2x.png'>
    <img class="product-icon" v-bind:style="getProductIconStyle"  v-bind:src="item.default_photo.large" v-if='item.default_photo'>
    <img class="product-icon" v-bind:style="getProductIconStyle" src="../../../assets/image/change-icon/default_image_02@2x.png" v-else>
    <span class="product-title">{{toNewName(item.name)}}</span>
    <div class="product-bottom">
      <span class="product-price">￥{{item.current_price || item.price}}</span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'HomeProductBody',
  data() {
    return {
      itemWidth : 0,
      itemHeight : 0,
      showRightBorder: this.index % 2 == 0,
    };
  },
  props: ['item', 'index'],
  computed: {
    getProductStyle: function () {
      const { width, height } = window.screen
      let itemWidth = width / 3 - 20 - 1;
      let itemHeight = itemWidth * (132.0 / 94.0);
      this.itemWidth = itemWidth;
      this.itemHeight = itemHeight;
      return {
        width: itemWidth + 'px',
        //height: itemHeight + 'px'
      }
    },
    getProductLabelStyle:function(){
      const { width, height } = window.screen
      let itemWidth = (this.itemWidth - 20)/4;
      let itemHeight = itemWidth;
      return {
        width: itemWidth + 'px',
        height: itemHeight + 'px',
        'margin-bottom': - itemHeight + 'px',
        'margin-left': - (this.itemWidth/2+itemWidth-10) + 'px',
        'align-self': 'left',
        'z-index': 300
      }
    },
    getProductIconStyle: function () {
      const { width, height } = window.screen
      let itemWidth = this.itemWidth - 20;
      let itemHeight = itemWidth;
      return {
        width: itemWidth + 'px',
        height: itemHeight + 'px'
      }
    },
  },
  methods: {
    productClick: function() {
      this.$router.push({'name': 'product', 'query': {'id': this.item.id}});
    },
    toNewName(name){
      const { width, height } = window.screen
      /*let itemWidth = this.itemWidth - 20;
      let wordNumber = Math.floor(itemWidth/14)
      if(name.length > wordNumber){
        return name.substring(0,wordNumber)+'...'
      }else{
        return name
      }*/
      let itemWidth = this.itemWidth - 4;
      let numofLine = Math.floor(itemWidth/14); // font-size:14px
      let attr = ''; 
      let delim = ' ';

      if (this.item.properties.length>0 && this.item.properties[0].attrs.length>0) {
        attr = (this.item.properties[0].attrs[0].attr_value+'/'+this.item.properties[0].name).trim();
      }/**/

      if (attr && (this.item.is_weight==2)) {
        attr = '约'+attr;
      }

      let wordNumber = numofLine*2*2-this.utils.strLen(attr)-this.utils.strLen(delim);  //1.2：显示一行多(1.2行)，后半行显示规格
      if(name && this.utils.strLen(name) <= numofLine*2){
        return name+(attr?"\n"+attr:'')
      }else if(name && (this.utils.strLen(name) >= wordNumber)){
        return name.substring(0,(wordNumber/2)-1)+'...'+(attr?delim+attr:'');
      }else{
        return name+(attr?delim+attr:'');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.border {
  border-right: 1px solid #F5F5F5;
}
.product-info {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 10px;
  justify-content: flex-end;
  border-bottom: 1px solid #F5F5F5;
  .product-icon {
    align-self: center;
  }
  .product-title {
    color: #333333;
    font-size: 14px;
    height:38px;
    margin-top: 10px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    white-space: pre-wrap;  // 允许强制换行
  }
  .product-bottom {
    display: flex;
    justify-content: space-between;
    margin-top: 6px;
    .product-price {
      color: #eb8419; // #666666;
      font-size: 12px;
      font-weight: 800;
    }
    .product-buy {
      color: #999999;
      font-size: 12px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/page/promotion-list/child/HomeProductBody.vue